import { useQuery } from 'react-query';
import { allBoostsByMonthQuery } from './useBoostsByMonth.query';
import {
  BoostsByMonthQueryResponse,
  UseBoostsByMonthQueryParams,
} from './useBoostsByMonth.types';

export const ALL_BOOSTS_BY_MONTH_QUERY_KEY = 'ALL_BOOSTS_BY_MONTH';

export const useBoostsByMonth = (params: UseBoostsByMonthQueryParams) => {
  return useQuery<BoostsByMonthQueryResponse, Error>(ALL_BOOSTS_BY_MONTH_QUERY_KEY, () =>
    allBoostsByMonthQuery(params)
  );
};
